<template>
    <div class="customer-data-container">
        <div class="content-container">
            <div class="personal-data-wrapper">
                <h1>Kundendaten ändern</h1>

                <EditPersonalData :customer="customer" @submit="handleSubmit"/>
            </div>
        </div>

        <PopUp title="Datenänderung beantragen" :open="showAreYouSure" submit-label="Beantragen" cancel-label="Abbrechen" @close="handleClose">
            <label>Ihre Änderungen werden beantragt. Nach dem Absenden kann es einige Tage dauern, bis Ihre Daten geprüft und aktualisiert werden.</label>
        </PopUp>
    </div>
</template>

<script>
import axios from 'axios'

import EditPersonalData from '@components/EditPersonalData.vue'
import PopUp from '@components/elements/PopUp.vue'

export default {
    name: 'customer-data-page',
    inject: [ 'util', 'globalState', 'toast' ],
    data() {
        return {
            customer: {},
            submitCustomer: undefined,
            showAreYouSure: false
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        customerId() {
            return encodeURIComponent(this.$route.params.id.replaceAll('+', '-').replaceAll('/', '_'))
        }
    },
    methods: {
        init() {
            this.globalState.isLoading = true

            let getCustomerUrl = this.util.middleware()
            getCustomerUrl += '/customers/' + this.customerId

            axios.get(getCustomerUrl)
            .then(response => {
                this.customer = response.data
                this.globalState.isLoading = false
            })
            .catch(() => {
                const errorMessage = this.$t('general.error')
                this.toast.error(errorMessage) 
            })
        },
        handleSubmit(event) {
            if (event) {
                this.submitCustomer = event
                this.showAreYouSure = true
            }
        },
        handleClose(event) {
            if (event) {
                this.globalState.isLoading = true

                let requestChangesUrl = this.util.middleware()
                requestChangesUrl += '/customers/' + this.submitCustomer.id

                //convert birthdate value to UTC timezone
                this.submitCustomer.birthdate = this.util.convertLocalToUtcDate(this.submitCustomer.birthdate)

                axios.put(requestChangesUrl, this.submitCustomer)
                .then(response => {
                    console.log(response)
                    this.submitCustomer = undefined
                    this.showAreYouSure = false
                    this.globalState.isLoading = false
                    this.$router.push('/')
                })
                .catch(() => {
                    this.showAreYouSure = false
                    this.submitCustomer = undefined
                    const errorMessage = this.$t('general.error')
                    this.toast.error(errorMessage) 
                })
            } else {
                this.submitCustomer = undefined
                this.showAreYouSure = false
            }
        }
    },
    components: {
        EditPersonalData,
        PopUp
    }
}
</script>

<style lang="scss" scoped>
.customer-data-container {
    width: 100%;

    > .content-container {
        padding-bottom: 16px;
    }
}

.personal-data-wrapper {
    background-color: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px #00000022;

    > h1 {
        margin: 0;
    }

    > div {
        margin-top: 40px;
    }
}
</style>